import { ElectronicAddressStatus } from '@/types'
import { Badge } from '@mantine/core'

const BADGES: Record<ElectronicAddressStatus, { label: string; color: string }> = {
  active: { label: 'Active', color: 'green' },
  unverified: { label: 'Non vérifiée', color: 'gray' },
  not_found: { label: 'Introuvable', color: 'red' },
}

export default function ElectronicAddressBadge({ status }: { status: ElectronicAddressStatus }) {
  return (
    <Badge variant="light" color={BADGES[status].color} style={{ flexShrink: 0 }}>
      {BADGES[status].label}
    </Badge>
  )
}
